import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { compose } from 'redux';
import { sendEvents } from '@fiverr-private/futile';
import { Icon } from '@fiverr-private/fit';
import { s_megaphone, s_comment } from '@fiverr-private/fit/icons';
import * as I18n from '../../lib/hoc';
import * as apps from '../../enums/apps';
import './style.scss';

export function ButtonTab({ name, onClick, count, active, i18n }) {
    const className = classNames('tab-switch', {
        active,
        [name]: true,
    });

    const handleClick = (e) => {
        const nameForEvent = ['inbox', 'conversations'].includes(name) ? 'inbox' : 'notifications';

        onClick(e, name);
        sendEvents({
            group: 'header_clicks',
            type: `clicked_header.${nameForEvent}`,
        });
    };

    return (
        <button className={className} onClick={handleClick}>
            <Icon className="tab-icon" size={14}>
                {getIcon(name)}
            </Icon>
            {i18n.t(`realtime_notifications.notifications_drawer.${name}`)} ({count})
        </button>
    );
}

function getIcon(name) {
    if (name === 'notifications') {
        return s_megaphone;
    }

    return s_comment;
}

ButtonTab.defaultProps = {
    name: apps.APP_NAME_INBOX,
    count: 0,
    active: false,
};

ButtonTab.propTypes = {
    name: propTypes.string,
    onClick: propTypes.func.isRequired,
    count: propTypes.number,
    active: propTypes.bool,
    i18n: propTypes.shape({
        t: propTypes.func,
    }),
};

export default compose(
    I18n.connect,
    connect(({ count }, { name }) => ({ count: count[name] }))
)(ButtonTab);
